<template>
  <div class="main-content-container overflow-hidden">
    <PageTitle pageTitle="Data Category Store" subTitle="Forms" />

    <ListAccessPermission />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/Common/PageTitle.vue";
import ListAccessPermission from "@/components/Pages/Master/AccessPermission/ListAccessPermission.vue";

export default defineComponent({
  name: "ListAccessPermissionPage",
  components: {
    PageTitle,
    ListAccessPermission,
  },
});
</script>
